const RhythmBlues = {
    name: "Rhythm Blues",
    bpm: 88,
    signature: "4/4",
    introMeasures: 4,
    pattern: [
        { cue: '1 l o, into 1 r i prog, into 2 l o', totalBeats: 4 },
        { cue: '4 r o swing', totalBeats: 4 },
        { cue: '2 l o, into 1 r i prog, into 1 l o, into 2 r i prog', totalBeats: 6 },
        { cue: '4 l i swing, into 4 r i swing', totalBeats: 8 },
        { cue: '1 l o, into 1 r i prog, into 2 l o', totalBeats: 4 },
        { cue: '2 cross-behind r i, into 2 l o, into 2 cross-behind r i', totalBeats: 6},
        { cue: 'repeat pattern', totalBeats: 0 },
    ]
};

export default RhythmBlues;